import { render } from "./IndexDropdown.vue?vue&type=template&id=61042d16"
import script from "./IndexDropdown.vue?vue&type=script&lang=js"
export * from "./IndexDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Dropdowns/IndexDropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61042d16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61042d16', __exports__)) {
    api.reload('61042d16', __exports__)
  }
  
  module.hot.accept("./IndexDropdown.vue?vue&type=template&id=61042d16", () => {
    api.rerender('61042d16', render)
  })

}


export default __exports__